var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import { muiCancelFill } from '@ally/metronome-icons';
import { Icon } from '../../Icon';
const StyledButton = styled.button `
  ${({ theme: { iconSize, baseIconSize } }) => {
    const iconPad = baseIconSize.md;
    return `
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      top: ${iconPad}px;
      right: ${iconPad}px;
      width: ${iconSize.lg};
      height: ${iconSize.lg};
      box-sizing: border-box;
      border: 1px solid transparent;
      background-color: transparent;
      cursor: pointer;
      padding: 0 !important;
      margin: 0 !important;
      overflow: visible;
    `;
}}
`;
const CloseButton = (_a) => {
    var { onClick, ariaLabel = 'close', allytmln } = _a, others = __rest(_a, ["onClick", "ariaLabel", "allytmln"]);
    return (React.createElement(StyledButton, Object.assign({ onClick: onClick }, others, { "aria-label": ariaLabel, "data-allytmln": allytmln, type: "button" }),
        React.createElement(Icon, { "aria-hidden": "true", icon: muiCancelFill, fill: "periwinkle-500", size: "lg" })));
};
const CloseButtonSpacer = styled.span `
  float: right;
  box-sizing: border-box;

  ${({ theme: { baseIconSize, space, media }, isFullScreenSmDown = false, }) => {
    const iconPad = baseIconSize.md;
    const spacerSize = 2 * iconPad + baseIconSize.lg;
    return `
      display: inline-block;
      width: ${spacerSize}px;
      height: ${spacerSize}px;
      min-height: ${spacerSize}px;

      ${isFullScreenSmDown
        ? `
            ${media.down('sm')} {
              display: block;
              width: 100%;
              border-bottom: 1px solid #DDDDDD;
              float: none;
            }`
        : ``}
    `;
}}
`;
export { CloseButton, CloseButtonSpacer };
//# sourceMappingURL=CloseButton.js.map